import { portalApiClient, withAuthHeaders } from '@/platform/http'

export const normalizePartnerId = (partnerId: string) =>
  partnerId.toLowerCase() === 'ash' ? 'demopartner' : partnerId

export const getPatientPartnerIds = (orgId: string) =>
  portalApiClient.org_partners_v2_auth_organizations__org_id__clients_get({
    params: { org_id: orgId },
  })

export const getPartners = async (options?: { authUserIdOverride?: string | number | null }) => {
  try {
    const data = await portalApiClient.partners_v2_clients_users_me_partners_get(
      withAuthHeaders({
        headers:
          options?.authUserIdOverride == null
            ? {}
            : { 'x-auth-user-id-override': String(options.authUserIdOverride) },
      }),
    )
    const partners = data.partners.map((partner) => ({
      ...partner,
      partner_id: normalizePartnerId(partner.partner_id),
    }))
    partners.sort((a, b) => a.partner_name.localeCompare(b.partner_name))
    return { error: null, data: partners }
  } catch (error) {
    const normalizedError =
      error instanceof Error ? error : new Error('Partners request failed', { cause: error })
    return { error: normalizedError, data: null }
  }
}
